module.exports = __webpack_public_path__ + "static/media/Privacy_Policy_Brightee_Marketing_AB.4ec69af5.pdf";